import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Dialog, Typography } from '@mui/material';
import React, { useRef } from 'react';
import { burstSuccessSpark } from '@ui/components/common/micro-interactions';
import { Card } from '../style';
import { black500, black400 } from '../../../../constants/color';
import { PrimaryButon } from '@ui/components/common/button/PrimaryButon';
export const ConfirmationDialog = ({ open, handleClose }) => {
    const titleRef = useRef(null);
    return (_jsx(Dialog, { open: open, onClose: handleClose, TransitionProps: { onEntered: () => burstSuccessSpark(titleRef.current) }, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, children: _jsxs(Box, { width: 700, sx: {
                ...Card,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }, children: [_jsx(Typography, { mt: 3, lineHeight: '48px', fontSize: '34px', fontWeight: 500, color: black500, children: _jsx("span", { ref: titleRef, children: "Hours uploaded successfully" }) }), _jsx(Typography, { variant: 'subtitle1', color: black400, children: "Hours approval is required to upload your invoice" }), _jsx(Box, { sx: { width: '50%', margin: 'auto' }, children: _jsx(PrimaryButon, { onClick: handleClose, children: "Close" }) })] }) }));
};
